import React from "react";
import MuiContainer from "@material-ui/core/Container";

function Container(props) {
  return <MuiContainer maxWidth="lg" {...props} />;
}

export default Container;
